import ApiService from "../services/api";

import { OccurrenceComment, OccurrenceCommentsResponse } from "../models/occurrence";

export const fetchComments = async (occurrenceId: string): Promise<OccurrenceCommentsResponse> => {

    const apiService = new ApiService();
    try {
        const response = await apiService.get<OccurrenceCommentsResponse>(`/occurrences/${occurrenceId}/comments`);
        if (response.status === 200) {
            return response.data;
        } else {
            return { content: [], totalElements: 0, totalPages: 0 };
        }
    } catch (error) {
        console.error(error);
        return { content: [], totalElements: 0, totalPages: 0 };
    }
}

export const createComment = async (occurrenceId: string, comments: string): Promise<OccurrenceComment> => {
    const apiService = new ApiService();
    try {
        const response = await apiService.post<OccurrenceComment>(`/occurrences/${occurrenceId}/comments`, { comments });
        if (response.status === 200) {
            return response.data;
        } else {
            return { uuid: '', authorId: '', authorName: '', commentedAt: new Date(), comments: '' };
        }
    } catch (error) {
        console.error(error);
        return { uuid: '', authorId: '', authorName: '', commentedAt: new Date(), comments: '' };
    }
}

export const updateComment = async (occurrenceId: string, commentId: string, comments: string): Promise<OccurrenceComment> => {
    const apiService = new ApiService();
    try {
        const response = await apiService.put<OccurrenceComment>(`/occurrences/${occurrenceId}/comments/${commentId}`, { comments });
        if (response.status === 200) {
            return response.data;
        } else {
            return { uuid: '', authorId: '', authorName: '', commentedAt: new Date(), comments: '' };
        }
    } catch (error) {
        console.error(error);
        return { uuid: '', authorId: '', authorName: '', commentedAt: new Date(), comments: '' };
    }
}

export const deleteComment = async (occurrenceId: string, commentId: string): Promise<void> => {
    const apiService = new ApiService();
    try {
        await apiService.delete(`/occurrences/${occurrenceId}/comments/${commentId}`);
    } catch (error) {
        console.error(error);
    }
}